import React, {useState} from 'react';
import DefaultModal from "../invoice/DefaultModal";
import {deepCopyObject} from "../../helper/helper";
import {Label} from "reactstrap";
import Alert from "react-s-alert";

const CreateGmkodModal = props => {
    const {modal, listener, closeModal} = props;
    const [data, setData] = useState({
        gmkod: null,
        aciklama: null,
        tckimlikno: null
    });

    const onChange = (e, name) => {
        let newData = deepCopyObject(data);
        if (e.target.value !== undefined && e.target.value !== null) {
            newData[name] = e.target.value;
            setData(newData);
        }
    }

    const save = () => {
        if (data.gmkod === null || data.aciklama === null || data.gmkod === "" || data.aciklama === "") {
            Alert.error('Boş alanları doldurunuz.', {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 5000,
                html: false
            });
        } else {
            listener(data);
        }
    }

    return (
        <DefaultModal
            isOpen={modal}
            size="lg"
            title="Hesap Kodu Oluştur."
            confirmBtnText="Kaydet"
            onConfirm={save}
            cancelBtnText={"Kapat"}
            onCancel={closeModal}
        >
            <div style={{padding: '10px'}}>
                <table>
                    <tr>
                        <td>
                            *Hesap Kodu:
                        </td>
                        <td>
                            <input type="text" name={"gmkod"} onChange={(e) => onChange(e, "gmkod")}/>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            *Açıklama:
                        </td>
                        <td>
                            <input type="text" name={"aciklama"} onChange={(e) => onChange(e, "aciklama")}/>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <Label for="odemeTuru">TCKN/VKN:</Label>
                        </td>
                        <td>
                            <input type="text" name={"tckimlikno"} onChange={(e) => onChange(e, "tckimlikno")}/>
                        </td>
                    </tr>
                </table>
            </div>
        </DefaultModal>
    );
};

export default CreateGmkodModal;